export const COLORS_LIGHT = {
    ACCENT: "#1294d9",
    NEUTRAL: "#fff",
    PRIMARY_BG: "#fff5eb",
    PRIMARY_SHAPES: "#FADFC6",
    SECONDARY_BG: "#edf1f9",
    DARK_GRAY: "#505050",
    MEDIUM_GRAY: "#707070",
    LIGHT_GRAY: "#909090",
    OFF_WHITE: "#f9f9f9",
    SECONDARY_ACCENT: "#ff7055",
    GOLD: "#d98d12",
    BLACK: "#000"
}

export const COLORS_DARK = {
    ACCENT: "#ff7055",
    NEUTRAL: "#fff",
    PRIMARY_BG: "#FADFC6",
    SECONDARY_BG: "#edf1f9",
    DARK_GRAY: "#505050",
    MEDIUM_GRAY: "#707070",
    LIGHT_GRAY: "#909090",
    OFF_WHITE: "#f9f9f9",
    SECONDARY_ACCENT: "#1294d9",
    GOLD: "#d98d12",
    BLACK: "#000"
}

export const TEXT = {

    FONT: "Montserrat",
    SIZE_7: "220%",
    SIZE_6: "200%",
    SIZE_5: "150%",
    SIZE_4: "120%",
    SIZE_3: "100%",
    SIZE_2: "95%",
    SIZE_1: "85%",
}